import FadeIn from './fadeIn.js';
export default FadeIn;
